import { SET_TENANT_SETTINGS } from "../actions/types";
import { DEFAULT_PERCENTAGE_FEE, DEFAULT_BOOKING_FEE_FIXED } from "../helpers/priceUtils";

// Per-tenant fee settings. `percentage` is a percent value (3 means 3%).
// Defaults match the platform defaults until tenant info loads.
const initialState = {
    percentage: DEFAULT_PERCENTAGE_FEE,
    fixed: DEFAULT_BOOKING_FEE_FIXED,
    // When true, the train list is shown as a calendar first (see TrainList).
    groupTrainsByDate: false,
};

function tenantReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_TENANT_SETTINGS:
            return {
                ...state,
                // Ignore null/undefined from the API so defaults are preserved.
                percentage: payload.percentage != null ? payload.percentage : state.percentage,
                fixed: payload.fixed != null ? payload.fixed : state.fixed,
                groupTrainsByDate: payload.groupTrainsByDate != null ? payload.groupTrainsByDate : state.groupTrainsByDate,
            };
        default:
            return state;
    }
}

export default tenantReducer;
